import { useEffect, useState } from 'react';
import type { BonusMove, CustomerBonus } from '@kassa/shared';
import { api, ApiError } from '../api';
import { formatDate, formatMoney } from '../format';

// Müştəri kartında bonus (KT-96): balans, faiz, hərəkətlər; əl ilə düzəliş yalnız bonus.adjust ilə (qeyd məcburi).

const REASON: Record<BonusMove['reason'], string> = {
  earn: 'Satışdan yığılan',
  spend: 'Satışda xərclənən',
  return_earn: 'Qaytarma — yığılan geri alındı',
  return_spend: 'Qaytarma — xərclənən geri qayıtdı',
  manual: 'Əl ilə düzəliş',
};

export function BonusPanel({ customerId, canAdjust }: { customerId: string; canAdjust: boolean }) {
  const [data, setData] = useState<CustomerBonus | null>(null);
  const [points, setPoints] = useState('');
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    api
      .customerBonus(customerId)
      .then((b) => !cancelled && setData(b))
      .catch((err: unknown) => !cancelled && setError(err instanceof ApiError ? err.message : 'Bonus yüklənmədi'));
    return () => {
      cancelled = true;
    };
  }, [customerId]);

  const adjust = async () => {
    setBusy(true);
    setError(null);
    try {
      setData(await api.customerBonusAdjust(customerId, Number(points), note.trim()));
      setPoints('');
      setNote('');
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Düzəliş alınmadı');
    } finally {
      setBusy(false);
    }
  };

  const n = Number(points);
  const valid = points !== '' && Number.isFinite(n) && n !== 0 && note.trim().length > 0;

  return (
    <section className="card card-wide" aria-label="Bonus">
      <h2>Bonus</h2>
      {error && (
        <p className="bad" role="alert">
          {error}
        </p>
      )}
      {!data && !error && <p className="muted">Yüklənir…</p>}
      {data && (
        <>
          <p>
            Balans: <strong>{formatMoney(data.balance)}</strong> <span className="muted">· faiz {data.pct}%</span>
          </p>
          {canAdjust && (
            <div className="role-new">
              <label className="field">
                Düzəliş (+/−)
                <input type="number" step="0.01" value={points} onChange={(e) => setPoints(e.target.value)} disabled={busy} />
              </label>
              <label className="field">
                Səbəb
                <input value={note} onChange={(e) => setNote(e.target.value)} maxLength={200} disabled={busy} />
              </label>
              <button type="button" className="btn-small" onClick={() => void adjust()} disabled={busy || !valid}>
                Bonusu düzəlt
              </button>
            </div>
          )}
          {data.moves.length > 0 && (
            <div className="product-list">
              {data.moves.map((m) => (
                <div key={m.id} className="product-row">
                  <span className="muted small">{formatDate(m.at)}</span>
                  <span>
                    {REASON[m.reason]}
                    {m.docNo ? ` · ${m.docNo}` : ''}
                    {m.note ? ` · ${m.note}` : ''}
                  </span>
                  <span className={m.points < 0 ? 'bad' : 'ok'}>{formatMoney(m.points)}</span>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </section>
  );
}
